import { ActiveTagType } from './ActiveTagType';

export const getTagIds = (tags: ActiveTagType[]) => tags.map((el) => el.id);
